import styled from 'styled-components/macro';

export const PasswordTextArea = styled.textarea`
    position: absolute;
    top: -10000000%;
    left: -10000000%;
`;
